// ** Type Import
import { OwnerStateThemeType } from './'

const Tabs = () => {
  return {
    MuiTabs: {
      styleOverrides: {
        root: ({ theme }: OwnerStateThemeType) => ({
          // Grey section separator below tabs
          borderBottom: `1px solid ${theme.palette.divider}`,
          // Increase spacing below tabs
          marginBottom: '24px'
        }),
        indicator: ({ theme }: OwnerStateThemeType) => ({
          // Accent color underline for selected tab
          backgroundColor: theme.palette.accent.main,
          height: 2
        }),
        vertical: ({ theme }: OwnerStateThemeType) => ({
          minWidth: 130,
          marginRight: theme.spacing(4),
          borderRight: `1px solid ${theme.palette.divider}`,
          // Reset horizontal styles for vertical tabs
          borderBottom: 'none',
          marginBottom: 0,
          '& .MuiTab-root': {
            minWidth: 130
          }
        })
      }
    },
    MuiTab: {
      defaultProps: {
        disableRipple: true
      },
      styleOverrides: {
        root: ({ theme }: OwnerStateThemeType) => ({
          lineHeight: 1.5,
          fontSize: '1rem',
          // Title Case - remove MUI's default uppercase transform
          textTransform: 'none' as const,
          // Grey text for unselected tabs
          color: theme.palette.text.secondary,
          // Padding for better spacing
          paddingBottom: theme.spacing(2),
          '&.Mui-selected': {
            // Primary text color and bold when selected
            color: theme.palette.text.primary,
            fontWeight: 700
          }
        }),
        textColorSecondary: ({ theme }: OwnerStateThemeType) => ({
          '&.Mui-selected': {
            color: theme.palette.text.secondary
          }
        })
      }
    }
  }
}

export default Tabs
